// #region API

export const TRADEIN_API = 'https://apix-test3.dlstradein.link/tmf-api/productCatalogManagement/v4/productOffering';
export const TRADEIN_API_KEY = 'djc0a0pjbDBUQVFaZjc3OVNPbzJZQnA4Z1IzaXZaV0M6U1lBdlVjbjlmVllPRzQ2dw==';
export const TRADEIN_API_DEV_KEY = 'S0FvNVJQUGhHcGpmN1F6T0ZDVkNWdThBbkFtZEIxVEI6ZldPdUdaZUNWWllWYWJSSg==';
export const TRADEIN_API_URL = '/tmf-api/productCatalogManagement/v4/productOffering';
export const TRADEIN_API_CREDENTIALS = {
    prod: {
        url: `https://eu2.api.vodafone.com${TRADEIN_API_URL}`,
        key: TRADEIN_API_KEY,
    },
    dev: {
        url: `https://eu2-stagingref.api.vodafone.com${TRADEIN_API_URL}`,
        key: TRADEIN_API_DEV_KEY,
    },
};

export const TRADE_IN_API_QUERY_PARAM = 'prodSpecCharValueUse' as const;

// #endregion

// #region Misc

export const TRADE_IN_OVERLAY_NAME = 'overlay-trade-in' as const;
export const TRADEIN_INPUT_DEBOUNCE_DURATION = 250;
export const TRADEIN_INPUT_MIN_LENGTH = 1;
export const TRADEIN_INPUT_MAX_LENGTH = 30; // this value is defined by the tradeIn API, it is not randomly picked.
export const TRADEIN_OPTION_PICKER_VALUE_YES = 'yes' as const;
export const TRADEIN_OPTION_PICKER_VALUE_NO = 'no' as const;
export const TRADEIN_OPTION_PICKER_VALUE_DEFAULT = TRADEIN_OPTION_PICKER_VALUE_NO;

// #endregion
